<template>
  <div
    ref="textContainer"
    :style="componentStyle"
    :class="['animated', { [conf.anim]: conf.anim }]"
  >
   <!-- @dblclick="handleDbClick" -->
    <!-- {{conf}} -->
    <div
      v-if="!isChangeEdit"
      :style="textStyle"
      ref="text1"
      :class="[{ oneline: isOneLine }]"
      v-html="textFix.split('\n').join('<br>')"
    ></div>
    <div v-else>
      <el-input
        ref="ta"
        v-model="conf.text"
        type="textarea"
        :style="taStyle"
        @blur="editing = false"
      />
    </div>
  </div>
</template>

<script>
import eventbus from "../../../utils/eventbus";
import store from "../../../store";

export default {
  name: "TumengText",
  components: {},
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editing: false,
      // 这个防抖用 16ms只能调用一次
      time: Number.MIN_SAFE_INTEGER,
      scale: 1,
    };
  },
  computed: {
    componentStyle() {
      // const { borderRadius } = this.conf;
      // const borderRadiusValue = `${borderRadius.leftTop}px ${borderRadius.rightTop}px ${borderRadius.rightBottom}px ${borderRadius.leftBottom}px`;
      // console.log(borderRadius)
      return {
        width: (this.conf.width - this.conf.borderWidth * 2) + "px",
        height: "100%",
        position: "relative",
        top: 0,
        userSelect: "none",
        padding: this.conf.padding + "px",
        display: "flex",
        justifyContent: this.conf.textAlign,
        alignItems: this.conf.verticalAlign,
        lineHeight: this.conf.lineHeight + "",
        fontSize: this.conf.fontSize + "px",
        color: this.conf.fontColor,
        // transform: 'rotate(' + this.conf.rotate + 'deg)',
        fontWeight: this.conf.isBold ? "bold" : "normal",
        fontStyle: this.conf.isItaly ? "italic" : "normal",
        textDecoration: this.conf.isUnderline,
        fontFamily: `'${this.conf.font}'`,
        whiteSpace: this.conf.autoTurn ? "inherit" : "nowrap",
        writingMode: this.conf.editDirection ? "vertical-lr" : "inherit",
        // borderRadius: borderRadiusValue,
        overflow: "hidden",
      };
    },
    taStyle() {
      return {
        height: this.conf.height + "px",
        fontSize: "24px",
      };
    },
    textStyle() {
      return {
        wdith: (this.conf.width - this.conf.borderWidth * 2) + "px",
        textDecoration: this.conf.isUnderline,
        textAlign:
          this.conf.textAlign == "center"
            ? "center"
            : this.conf.textAlign == "flex-start"
            ? "left"
            : "right",
        // transform: "scale(" + this.scale + ")",
        zoom: this.scale,
        fontSize: this.conf.fontSize + "px",
        textDecoration: this.conf.isUnderline,
      };
    },
    textFix() {
      const changeLineFlag = this.conf.changeLineFlag
        ? this.conf.changeLineFlag
        : "#line#";
      const replaceReg = new RegExp(changeLineFlag, "g");
      const textSplice = (this.conf.preText
        ? this.conf.preText
        : "") + this.conf.text + (this.conf.sufText
        ? this.conf.sufText
        : "");
      return textSplice
        .replace(replaceReg, "\n")
        .replace(/#mark#/g, "'")
        .replace(/#marks#/g, '"');
    },
    isOneLine() {
      return (
        this.conf.scrollDirection === "left" ||
        this.conf.scrollDirection === "right"
      );
    },
    isChangeEdit() {
      if (store.state.activeComponent) {
        return (
          this.conf.componentId === store.state.activeComponent.componentId &&
          this.editing
        );
      }
      return this.editing;
    },
  },
  watch: {
    "conf.text"() {
      this.conf.text = this.conf.text
        .replace(/\r\n/g, "#line#")
        .replace(/\n/g, "#line#")
        .replace(/\t/g, "#line#")
        .replace(/'/g, "#mark#")
        .replace(/\"/g, "#marks#");
      // this.scrollAnimation();
    },
    "conf.textDecoration"(val) {
      console.log(val);
    },

    conf: {
      handler() {
        // console.group('开始变化scale')
        this.changeScale();
        // console.groupEnd('结束了')
      },
      deep: true,
    },
  },
  filters: {
    htmlFix(html) {
      return html
        .replace(/#line#/g, "\n")
        .replace(/#mark#/g, "'")
        .replace(/#marks#/g, '"');
    },
  },
  created() {
    this.scrollAnimation();
    if (!this.preview) {
      this.$watch(
        () => {
          return this.conf.scrollDirection;
        },
        () => {
          this.scrollAnimation();
        }
      );
    }

    eventbus.$on("click-component", (id) => {
      if (this.editing && id === this.conf.id) {
        // this.$refs.ta.focus()
      }
    });
    this.$once("beforeDestroy", () => {
      eventbus.$off("click-component");
    });
  },
  methods: {
    handleDbClick() {
      if (!this.preview) {
        this.editing = true;
        setTimeout(() => {
          this.$refs.ta.focus();
        }, 100);
      }
    },
    scrollAnimation() {
      if (Date.now() < this.time) {
        return;
      }
      this.time = Date.now() + 16;
      setTimeout(() => {
        if (this.conf.scrollDirection) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
          }
          const listWrapper = this.$refs.textContainer;
          const noticeList1 = this.$refs.text1;

          const _subStr = (str) => {
            const index = str.indexOf("px");
            if (index > -1) {
              return parseFloat(str.substr(0, index + 1));
            }
          };

          const sd = this.conf.scrollDirection;
          if (sd === "up") {
            listWrapper.style.top = "0px";
            listWrapper.style.left = "0px";
            this.intervalId = setInterval(() => {
              if (
                Math.abs(_subStr(listWrapper.style.top)) >=
                noticeList1.clientHeight
              ) {
                listWrapper.style.top = "0px";
              } else {
                const top = listWrapper.style.top;
                listWrapper.style.top =
                  (-1 * this.conf.speed) / 20 + _subStr(top) + "px";
              }
            }, 16);
          } else if (sd === "down") {
            listWrapper.style.top = -1.0 * noticeList1.clientHeight + "px";
            listWrapper.style.left = "0px";
            this.intervalId = setInterval(() => {
              if (_subStr(listWrapper.style.top) >= 0) {
                listWrapper.style.top = -1.0 * noticeList1.clientHeight + "px";
              } else {
                const top = listWrapper.style.top;
                listWrapper.style.top =
                  this.conf.speed / 20 + _subStr(top) + "px";
              }
            }, 16);
          } else {
            // 判断宽度有没有超出，没有超出没办法滚动
            if (noticeList1.scrollWidth / 2 > listWrapper.clientWidth) {
              if (sd === "left") {
                listWrapper.style.left = "0px";
                listWrapper.style.top = "0px";
                this.intervalId = setInterval(() => {
                  if (
                    _subStr(listWrapper.style.left) <
                    (-1.0 * noticeList1.scrollWidth) / 2
                  ) {
                    listWrapper.style.left = "0px";
                  } else {
                    const left = listWrapper.style.left;
                    listWrapper.style.left =
                      (-1 * this.conf.speed) / 20 + _subStr(left) + "px";
                  }
                }, 16);
              } else if (sd === "right") {
                listWrapper.style.left =
                  (-1 * noticeList1.scrollWidth) / 2 + "px";
                listWrapper.style.top = "0px";
                this.intervalId = setInterval(() => {
                  if (_subStr(listWrapper.style.left) > 0) {
                    listWrapper.style.left =
                      (-1 * noticeList1.scrollWidth) / 2 + "px";
                  } else {
                    const left = listWrapper.style.left;
                    listWrapper.style.left =
                      this.conf.speed / 20 + _subStr(left) + "px";
                  }
                }, 16);
              }
            }
          }
        } else {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = undefined;
            const listWrapper = this.$refs.textContainer;
            listWrapper.style.top = "0px";
            listWrapper.style.left = "0px";
          }
        }
      }, 100);
    },

    changeScale() {
      // console.log(123);
      if (!this.conf.autoZoom) {
        // 超出隐藏直接不处理
        this.scale = 1;
        return;
      }
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      // 内容的宽
      const allText = this.conf.preText + this.conf.text + this.conf.sufText;
      const allTextStyle = this.conf.fontSize + "px " + this.conf.font;
      context.font = allTextStyle;
      const textWidth = context.measureText(allText).width;
      // 文本组件实际文本显示区域的宽，需要减掉组件边框
      const confContentWidth = this.conf.width - this.conf.borderWidth * 2

      // console.log(textWidth);

      if (textWidth > confContentWidth && this.conf.autoZoom) {
        //autoZoom true自动缩放
        const prec = (textWidth + 10 - confContentWidth) / textWidth;
        this.scale = 1 - prec.toFixed(2);
      } else {
        this.scale = 1;
      }
    },
  },
  mounted() {
    this.changeScale();
  },
};
</script>
<style>
@font-face {
  font-family: "Alimama DaoLiTi";
  src: url("fonts/AlimamaDaoLiTi.ttf") format("ttf"),
    url("fonts/AlimamaDaoLiTi.woff") format("woff"),
    url("fonts/AlimamaDaoLiTi.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alibaba PuHuiTi 3.0 35 Thin";
  src: url("fonts/AlibabaPuHuiTi-3-35-Thin.woff2") format("woff2"),
    url("fonts/AlibabaPuHuiTi-3-35-Thin.woff") format("woff"),
    url("fonts/AlibabaPuHuiTi-3-35-Thin.ttf") format("ttf"),
    url("fonts/AlibabaPuHuiTi-3-35-Thin.otf") format("otf"),
    url("fonts/AlibabaPuHuiTi-3-35-Thin.eot") format("eot");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alibaba PuHuiTi 3.0 45 Light";
  src: url("fonts/AlibabaPuHuiTi-3-45-Light.woff2") format("woff2"),
    url("fonts/AlibabaPuHuiTi-3-45-Light.woff") format("woff"),
    url("fonts/AlibabaPuHuiTi-3-45-Light.ttf") format("ttf"),
    url("fonts/AlibabaPuHuiTi-3-45-Light.otf") format("otf"),
    url("fonts/AlibabaPuHuiTi-3-45-Light.eot") format("eot");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alibaba PuHuiTi 3.0 55 Regular";
  src: url("fonts/AlibabaPuHuiTi-3-55-Regular.woff2") format("woff2"),
    url("fonts/AlibabaPuHuiTi-3-55-Regular.woff") format("woff"),
    url("fonts/AlibabaPuHuiTi-3-55-Regular.ttf") format("ttf"),
    url("fonts/AlibabaPuHuiTi-3-55-Regular.otf") format("otf"),
    url("fonts/AlibabaPuHuiTi-3-55-Regular.eot") format("eot");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alibaba PuHuiTi 3.0 65 Medium";
  src: url("fonts/AlibabaPuHuiTi-3-65-Medium.woff2") format("woff2"),
    url("fonts/AlibabaPuHuiTi-3-65-Medium.woff") format("woff"),
    url("fonts/AlibabaPuHuiTi-3-65-Medium.ttf") format("ttf"),
    url("fonts/AlibabaPuHuiTi-3-65-Medium.otf") format("otf"),
    url("fonts/AlibabaPuHuiTi-3-65-Medium.eot") format("eot");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alimama DongFangDaKai";
  src: url("fonts/AlimamaDongFangDaKai-Regular.woff2") format("woff2"),
    url("fonts/AlimamaDongFangDaKai-Regular.woff") format("woff"),
    url("fonts/AlimamaDongFangDaKai-Regular.ttf") format("ttf"),
    url("fonts/AlimamaDongFangDaKai-Regular.otf") format("otf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alimama FangYuanTi VF";
  src: url("fonts/AlimamaFangYuanTiVF-Thin.woff2") format("woff2"),
    url("fonts/AlimamaFangYuanTiVF-Thin.woff") format("woff"),
    url("fonts/AlimamaFangYuanTiVF-Thin.ttf") format("ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Alimama ShuHeiTi";
  src: url("fonts/AlimamaShuHeiTi-Bold.woff2") format("woff2"),
    url("fonts/AlimamaShuHeiTi-Bold.woff") format("woff"),
    url("fonts/AlimamaShuHeiTi-Bold.ttf") format("ttf"),
    url("fonts/AlimamaShuHeiTi-Bold.otf") format("otf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "DingTalk JinBuTi";
  src: url("fonts/DingTalk-JinBuTi.woff2") format("woff2"),
    url("fonts/DingTalk-JinBuTi.woff") format("woff"),
    url("fonts/DingTalk-JinBuTi.ttf") format("ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "OPPO Sans Medium";
  src: url("fonts/OPPOSans-Medium.otf") format("otf"),
    url("fonts/OPPOSans-Medium.ttf") format("ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "OPPO Sans";
  src:url("fonts/OPPOSans-Regular.ttf") format("ttf");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Gagalin";
  src: url("fonts/Gagalin-Regular.ttf") format("ttf");
  font-weight: normal;
  font-style: normal;
}
</style>
<style lang="scss" scoped>
.oneline {
  word-break: keep-all;
  white-space: nowrap;
  display: flex;
}

.el-textarea {
  ::v-deep .el-textarea__inner {
    height: 100%;
  }
}
</style>
